import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { MenuOutlined } from '@ant-design/icons';
import styles from '../index.module.scss';
import React from 'react';

const SortableRow = ({ children, ...props }) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id: props['data-row-key'] });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    // Clone children and inject drag handle into the first cell
    const childrenArray = React.Children.toArray(children);
    const enhancedChildren = childrenArray.map((child, index) => {
        if (index === 0) {
            return React.cloneElement(child, {
                children: (
                    <MenuOutlined
                        {...attributes}
                        {...listeners}
                        style={{ cursor: 'move', color: '#999', fontSize: '16px' }}
                    />
                ),
            });
        }
        return child;
    });

    return (
        <tr
            ref={setNodeRef}
            style={style}
            className={`${styles.sortableRow} ${isDragging ? styles.dragging : ''}`}
            {...props}
        >
            {enhancedChildren}
        </tr>
    );
};

export default SortableRow;
